import React, { Component } from 'react';
import AccountService from '../services/AccountService';
import LocalDataManager from '../managers/LocalDataManager';
import { TextField, Button } from 'react-md';


export default class TestPage extends Component {

    constructor(props) {
        super(props);
        this.defaultProps = {}
        this.state = {
            errors: {},
            inputVals: {
                message: ""
            }
        }
        this.accountService = new AccountService();
        this.dbm = new LocalDataManager();

        this.settings = this.dbm.getSettingsInfo();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSave = this.handleSave.bind(this);

        let self = this;
        self.props.superInit(self.props.loadingOff, undefined, undefined, undefined);

        // this.props.loadingOff();
    }



    componentDidMount() { }

    componentWillReceiveProps() {
        this.props.loadingOff();
    }

    checkAllErrors() {
        var keys = Object.keys(this.state.inputVals)
        let hasErrors = false;
        let errors = {};
        _.each(keys, (key) => {
            errors[key] = this.checkErrors(key, this.state.inputVals[key]);
            if (errors[key] != undefined) {
                hasErrors = true;
            }
        });

        if (hasErrors)
            this.setState({ errors: errors });

        return hasErrors;
    }

    checkErrors(property, value) {
        var error = undefined;
        var requiredProps = ["message"];
        if (requiredProps.includes(property)) {
            if (value === null || value === undefined || value.toString().trim() === "") {
                error = "This field is required.";
            }
        }

        return error;
    }

    handleInputChange(property, value, e) {

        let inputVals = this.state.inputVals;
        inputVals[property] = value;

        let errors = this.state.errors;
        errors[property] = this.checkErrors(property, value);

        this.setState({ errors: errors, inputVals: inputVals });
    }

    handleSave() {
        let self = this;
        if (!this.checkAllErrors()) {
            this.dbm.getAuthInfo().then((result) => {
                self.state.inputVals.userId = result.userId;
                self.accountService.saveFeedback(self.state.inputVals, (result) => {
                    alert("Thank you! Your feedback has been submitted.");
                    self.state.inputVals.message = "";
                    self.setState({ inputVals: self.state.inputVals })
                }, (err) => {

                    alert("Thank you! Your feedback has been submitted.");
                    self.state.inputVals.message = "";
                    self.setState({ inputVals: self.state.inputVals })
                });
            });
        }
    }

    render() {
        return (
            <div id="page-outer">
                <div className="profile-top-bar-outer">
                    <div className="profile-top-bar-menu-button material-icons" onClick={this.props.toggleNav}>menu</div>
                    <div className="profile-top-bar-title-container">Feedback</div>
                    <div className="profile-top-bar-flashmenu-button material-icons">&nbsp;</div>
                </div>
                <div className="profile-central-outer" style={{ height: 'calc(100% - 5.5rem)' }}>

                    <div className="profile-central-regular-card-container">
                        <div className="profile-central-title-container">
                            <div className="profile-central-title">{"We'd love to hear from you!"}</div>
                            <div className="profile-central-subtitle">Let us know what we are doing well, and what we can improve on!</div>
                        </div>
                        <div className="profile-view-manage-outer">
                            <TextField
                                id="feedback-data-text"
                                label="What would you like to tell us?"
                                lineDirection="center"
                                placeholder=""
                                rows={5}
                                value={this.state.inputVals.message}
                                className="feedback-field"
                                onChange={this.handleInputChange.bind(null, "message")}
                                error={this.state.errors["message"] != undefined}
                                errorText={this.state.errors["message"]}
                            />
                            <div className="profile-bottom-buttons" style={{ marginTop: '2rem' }}>
                                <Button flat onClick={this.handleSave}>Save</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
